import { MessageCentreThreadType } from '@ukpostbox/client-data';
import { MessageCentreResponseType } from '@ukpostbox/client-data/lib/Types/Response/MessageCentreResponseTypes';
import { useTranslation } from '@ukpostbox/frontend-framework';
import { useState } from 'react';
import { UseThreadActionsType } from '../Types/MessageCentreHookTypes';

const useThreadActions = (): UseThreadActionsType => {
	const { t } = useTranslation();
	const [selectionActions, setSelectionActions] = useState<any>(null);

	const FilterActions = (messageData: any, selected: any) => {
		if (!messageData || !selected || selected.length < 1) {
			setSelectionActions(null);
			return;
		}

		const messageActionsData = [
			{
				name: 'Archive',
				label: t('actions.archive'),
				id: 0,
			},
			{
				name: 'Un-Archive',
				label: t('actions.unArchive'),
				id: 1,
			},
			{
				name: 'Delete',
				label: t('actions.delete'),
				id: 2,
			},
		];

		const selectedData: Array<MessageCentreThreadType> = messageData.pages
			? messageData.pages.map((group: MessageCentreResponseType) =>
					group.data.filter((messageItem) => (selected.includes(messageItem.id) ? messageItem : null)),
				)[0]
			: [messageData];

		const newActions: Array<any> = messageActionsData;
		const exclude: Array<string> = [];

		for (let i = 0; i < selectedData.length; i += 1) {
			if (selectedData[i].isArchived && !exclude.includes('Archive')) {
				exclude.push('Archive');
			}
			if (!selectedData[i].isArchived && !exclude.includes('Un-Archive')) {
				exclude.push('Un-Archive');
			}
		}

		if (exclude.length > 0) {
			const exclusions = exclude.filter((v, i, a) => a.indexOf(v) === i);

			for (let m = 0; m < newActions.length; m += 1) {
				newActions[m].disabled = exclusions.includes(newActions[m].name);
			}
		}

		setSelectionActions(newActions);
	};

	return { selectionActions, FilterActions };
};

export default useThreadActions;
